
import { Component, OnInit, ViewChild } from '@angular/core';
import { Platform, ModalController, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService, MessageclientService, NativeService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from 'src/model/common';
import { GiftAuditModalPage } from "src/app/page/nestle/gift-audit-modal/gift-audit-modal.page";
declare var app;
@Component({
  selector: 'app-gift-audit-list',
  templateUrl: './gift-audit-list.component.html',
  styleUrls: ['./gift-audit-list.component.scss']
})
export class GiftAuditListComponent extends GridBaseCase {
  tabsIndex: any = 0;
  remarkvalue: any; //信息反馈字段
  outOrInType: string;//调出或者调入类型type
  outOrInName: string;
  pageName: string = null;
  auditsearchValue: any = "";
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  dataArrayList: Array<any> = [];//数据列表
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController,
  ) {
    super();
    this.baseService.arrayData = [];
    // this.getProductList();
    // this.baseService.FixedSubmitBtn.configName = "GiftAuditList";
    // this.baseService.FixedSubmitBtn.isShow = true;
    // this.baseService.FixedSubmitBtn.type = 18;
    this.LoadData(1);
  }
  /**
   * $event,'search
   * @param ev 
   * @param searchType 
   */
  serarEvent(ev, searchType) {
    this.LoadData(1);
  }

  /**
   * checkbox 改变事件
   * @param item 
   * @param i 
   * @param event 
   */
  checkItem(item, i, event) {
    const that = this;
    if (item.isCheck) {
      item.isCheck = false;
    } else {
      item.isCheck = true;
    }
    let istrue: number = 0;
    that.baseService.arrayData.forEach(items => {
      if (items.isCheck) {
        istrue++;
      }
    });
    if (istrue == that.baseService.arrayData.length) {
      that.baseService.FixedSubmitBtn["isCheckAll"] = true;
    } else {
      that.baseService.FixedSubmitBtn["isCheckAll"] = false;
    }
  }
  /**
   * 
   * @param e 跳转页面
   */
  EventLink(event, item) {
    let json = {
      ID: item.ID,
      ImgUrl: item.ImgUrl,
      FK_TBStore_ID: item.FK_TBStore_ID,//赠品id
      SignerName: item.ChineseName, // 签收人
      FK_TBStore_Name: item.FK_TBStore_Name, // 门店名称
      SignTimeEffect: item.SignTime,// 日期
      SignState: item.SignState, // 返回的签收状态
      MessageFeedback: item.MessageFeedback // 备注
    };
    this.com.setHistoryUrl(true);
    // this.router.navigate(["/tabs/contact/GiftAuditDetail/" + this.com.getNowDatetime], {
    //   queryParams: {
    //     JsonData:
    //       JSON.stringify(json)
    //   }
    // });
    this.com.Go("/tabs/contact/GiftAuditDetail/" + this.com.getNowDatetime,{
      JsonData:JSON.stringify(json)
    });
    // that.router.navigate(["/tabs/contact/GiftReceiptForm/"+this.com.getNowDatetime], {
    //   queryParams: {
    //     ID:item.ID,
    //     FK_TBStore_ID: id,//赠品id
    //     SignerName: item.SignerName, // 签收人
    //     FK_TBStore_Name: item.FK_TBStore_Name, // 门店名称
    //     SignTimeEffect: item.SignTimeEffect,// 日期
    //     SignState:item.SignState, // 返回的签收状态
    //     MessageFeedback:item.MessageFeedback // 备注
    //   }
    // });
  }

  ngOnInit() {
  }
  // tab切换
  ipcConten(num) {
    this.tabsIndex = num;
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.baseService.arrayData.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }

  LoadData(PageNumber) {
    var that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }

    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "TBGiftQuotaCheckXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    //ExamineState  1 审批通过  2 审批拒绝  3 待审批   4 无需审批
    typeObj["ExamineState"] = 3;
    typeObj["ChineseName"] = that.auditsearchValue;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {

      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.baseService.arrayData = [];
        // that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {

        data.Status.Datas.forEach(function (item) {
          item["isCheck"] = false;
          if(item.SignTimeEffect){
            item.SignTimeEffect=item.SignTimeEffect.replace(/-/g,"/").replace("T","");
          }
          if(item.SignTime){
            item.SignTime=item.SignTime.replace(/-/g,"/").replace("T","");
          }
          that.baseService.arrayData.push(item);
        });
        that.dataArrayList = data.Status.Datas;
        console.log(that.dataArrayList, "dataArrayList");
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.baseService.arrayData.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }

  RemarkInput(e) {
    let that = this;
    if (e && e.target.value) {
      if (e.target.value.length > 120) {
        e.target.value = e.target.value.substr(0, 120);
        that.remarkvalue = e.target.value;
      }
    }
  }

  //提交按钮
  EventSubmitClick(btnType: any = true) {
    var that = this;
    if (btnType) {
      console.log("GiftAuditList 通过");
    } else {
      console.log("GiftAuditList  拒绝");
    }
    console.log("提交 json", this.baseService.arrayData);
    console.log("提交 json", this.dataArrayList);
    let curr_list = [];
    let bohui_list=[];
    that.dataArrayList.forEach(item => {
      if (item.isCheck) {
        let curr_obj = {};
        let bohui_obj={};
        curr_obj["FK_TBGiftQuota_ID"] = item.ID || "";
        curr_obj["FK_TBStore_ID"] = item.FK_TBStore_ID || "";
        curr_list.push(curr_obj);
        //拒绝只穿id 不传  tbstoreid
        bohui_obj["FK_TBGiftQuota_ID"] = item.ID || "";
        bohui_list.push(bohui_obj);
      }
    });
    if (!that.dataArrayList.find(n => n.isCheck == true)) {
      that.msg.Alert("请选中一条数据");
      return;
    }

    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "TBGiftQuotExamine";
    body.OpType = "edite";
    body.ConfigType = "form";
    body.RowsPerPage = 1000;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    //ExamineState  1 审批通过  2 审批拒绝  
    if(!btnType)
    {
      //拒绝走另一个接口
      // typeObj["ExamineState"] = btnType ? 1 : 2;
      //ids 一个id 时 为0，多个为1
      typeObj["whetherSingle"] = curr_list.length > 1 ? 1 : 0;
  
      typeObj["giftQuotaListID"] = bohui_list;
      body.ConfigName="TBGiftQuotReject";
      that.presentModal(body, typeObj);
    }else{
    // typeObj["ExamineState"] = btnType ? 1 : 2;
    //ids 一个id 时 为0，多个为1
    typeObj["whetherSingle"] = curr_list.length > 1 ? 1 : 0;

    typeObj["giftQuotaListID"] = curr_list;
    console.log("提交 json", typeObj);
    that.Submit(body, typeObj);
    }
   
  }

  Submit(body, typeObj) {
  {
    const that=this;
    body.RequestBody = JSON.stringify(typeObj);
    that.msg.Loading("请稍后...").then(loads => {
      that.http.post(app.DEFAULTURL, body).then(data => {
        setTimeout(function () {
          loads.dismiss();
        }, 100);
        if (data.ResponseMessage.Success) {
          that.msg.Alert("操作成功！");
          that.LoadData(1);
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(err => {
        loads.dismiss();
        that.msg.Alert("网络异常，请稍后再试！");
      });

    })
  }
}

 

async presentModal(body: any = new WebParameterContext(), requestObj: any) {
  const modal = await this.modal.create({
    component: GiftAuditModalPage,
    cssClass: 'my-custom-class',
    componentProps: {
      'configName': this.pageName,
    }
  });

  await modal.present();
  const { data } = await modal.onWillDismiss();
  if (data && data.request) {
    let remark = data["result"] || "";
    console.log("modalww", this.baseService.arrayData);
    requestObj["dismissReason"] = remark;
    this.Submit(body, requestObj);
    console.log("submit", requestObj);
  } else {
    return;
  }
}

  /**
 * 全选状态切换
 */
  EventCheckAllToggle() {
    console.log("EventCheckAllToggle");
    const that = this;
    if (that.baseService.FixedSubmitBtn["isCheckAll"]) {
      that.baseService.arrayData.forEach(items => {
        console.log(items, "集合");
        items.isCheck = true;
      });
    } else {
      that.baseService.arrayData.forEach(items => {
        items.isCheck = false;
      });
    }
  }
}
